import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Col, Container, Input, Label, Row } from 'reactstrap'
import {
  InputEmail,
  InputNumber,
  InputPassword,
  InputText
} from '../../../components/inputs'
import Select from 'react-select'
import { enumTypesPersons as entities, fakeDataSignature, typesPersons } from './options'
import Divider from '../../../components/divider'
import InputSelect from '../../../components/inputs/select'

const FormBase = ({input = {}}) => {
  const { LEGAL, NATURAL } = entities
  const {
    control,
    setValue,
    formState: { errors }
  } = useFormContext()

  const [entitySelected, setEntity] = React.useState('N')

  const handleOnchangeSelectEntity = (e) => {
    setEntity(e.value)
    setValue('nit', '')
    setValue('dui', '')
  }

  const [servicesSelected, setServicesSelected] = React.useState({
    service_to_acquire_digital_signature: [],
    service_to_acquire_digital_invoice: []
  })

  const handleOnchangeSignatureDigital = (e) => {
    setServicesSelected({
      ...servicesSelected,
      service_to_acquire_digital_signature: e
    })
  }

  const handleOnchangeDigitalInvoice = (e) => {
    setServicesSelected({
      ...servicesSelected,
      service_to_acquire_digital_invoice: e
    })
  }

  console.log('Errors', errors)

  return (
    <React.Fragment>
      {/* <Row className="mx-0" style={{ paddingTop: '2%', paddingLeft: '5%' }}> */}
      <Divider title="Información principal" />
      <Row className="mb-1">
        <Col md="3" sm="6">
          <Label>Tipo de persona</Label>
          <Select
            aria-label="Tipo de persona"
            name='type_of_entity'
            id='type_of_entity'
            value={typesPersons.find((item) => item.value === entitySelected)}
            options={typesPersons}
            onChange={handleOnchangeSelectEntity}
            isDisabled={input?.type_of_entity?.disabled}
          />
        </Col>
        <Col md="3" sm="6">
          {entitySelected === NATURAL && (
            <InputNumber
              label={'DUI*'}
              errors={errors}
              control={control}
              disabled={input?.dui?.disabled}
              options={{
                id: 'dui',
                name: 'dui',
                maxLength: 9,
                required: true,
                startWithCero: true
              }}
            />
          )}
          {entitySelected === LEGAL && (
            <InputNumber
              label={'NIT*'}
              errors={errors}
              control={control}
              disabled={input?.nit?.disabled}
              options={{
                id: 'nit',
                name: 'nit',
                maxLength: 14,
                required: true,
                startWithCero: true
              }}
            />
          )}
        </Col>

        <Col md="6" sm="12">
          <InputNumber
            label={'NRC*'}
            errors={errors}
            control={control}
            disabled={input?.nrc?.disabled}
            options={{
              id: 'nrc',
              name: 'nrc',
              maxLength: 14,
              required: true,
              startWithCero: true
            }}
          />
        </Col>
      </Row>

      <Row className="mb-1">
        <Col md="6" sm="12">
          <InputText
            label={'Nombre de la Sociedad*'}
            errors={errors}
            required
            options={{
              control,
              id: 'society',
              name: 'society'
              // disabled: true
            }}
          />
        </Col>

        <Col md="6" sm="12">
          <InputText
            label={'Tipo de establecimiento*'}
            errors={errors}
            required
            options={{
              control,
              id: 'type_of_establishment',
              name: 'type_of_establishment'
              // disabled: true
            }}
          />
        </Col>
      </Row>

      <Row className="mb-1">
        <Col md="6" sm="12">
          <InputText
            label={'Dirección*'}
            errors={errors}
            required
            options={{
              control,
              id: 'address',
              name: 'address'
              // disabled: true
            }}
          />
        </Col>

        <Col md="6" sm="12">
          <InputNumber
            label={'Teléfono*'}
            errors={errors}
            control={control}
            options={{
              id: 'phone',
              name: 'phone',
              maxLength: 8
            }}
          />
        </Col>
      </Row>

      <Row className="mb-1">
        <Col md="6" sm="12">
          <InputText
            label={'Actividad Económica*'}
            errors={errors}
            required
            options={{
              control,
              id: 'economic_activity',
              name: 'economic_activity'
              // disabled: true
            }}
          />
        </Col>
        <Col md="6" sm="12">
          <InputText
            label={'Nombre del administrador principal*'}
            errors={errors}
            required
            options={{
              control,
              id: 'main_admin_name',
              name: 'main_admin_name'
              // disabled: true
            }}
          />
        </Col>
      </Row>
      <Row  className="mb-1">
      <Col style={{display: "flex", alignItems: "flex-end"}}>
          <Label check>
                  <Controller
                      name="largeConsumer"
                      control={control}
                      render={({ field }) => (
                          <Input
                              {...field}
                              type="checkbox"
                              id="largeConsumer"
                              checked={field.value}
                              invalid={!!errors.largeConsumer}
                          />
                      )}
                  />{' '}
                  Gran consumo
              </Label>
        </Col>
      </Row>

      <Row className="mb-1">
        <Col md="6" sm="12">
          <InputEmail
            label="Correo Electrónico"
            errors={errors}
            control={control}
            options={{
              id: 'main_admin_email',
              name: 'main_admin_email'
            }}
          />
        </Col>
        <Col md="6" sm="12">
          <InputPassword
            label={'Restablecer contraseña*'}
            errors={errors}
            control={control}
            options={{
              id: 'reset_main_admin_password',
              name: 'reset_main_admin_password'
            }}
          />
        </Col>
      </Row>

      <Divider title="Servicio a adquirir" />

      <Row className="mb-1">
        <Col md="6" sm="12">
          <Label>Firma digital</Label>
          <InputSelect
            label="Lista de servicios de firma digital"
            control={control}
            errors={errors}
            onChange={handleOnchangeSignatureDigital}
            options={{
              id: 'service_to_acquire_digital_signature',
              name: 'service_to_acquire_digital_signature',
              options: fakeDataSignature,
              isMulti: true
            }}
          />
        </Col>
        <Col md="6" sm="12">
          <Label>Factura Digital</Label>
          <InputSelect
            label="Servicios de factura digital"
            control={control}
            errors={errors}
            onChange={handleOnchangeDigitalInvoice}
            options={{
              id: 'service_to_acquire_digital_invoice',
              name: 'service_to_acquire_digital_invoice',
              options: fakeDataSignature,
              isMulti: true
            }}
          />
        </Col>
      </Row>

      <Row className="mb-1 mt-2">
        <Col md="6" sm="12">
          <Input type='checkbox' id='isActive' name='isActive' />{ " " }
          <Label for='isActive' className=' fw-bold'> Activo</Label>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default FormBase
